import { z } from 'zod';
import { defineCollection, type RecordOf } from '../collection.ts';
import { id, isoDateTime, provenance, requiredText, shortText } from '../fields.ts';

export const albums = defineCollection({
  name: 'albums',
  module: 'photos',
  label: { one: 'album', other: 'albums' },
  schema: z.object({
    title: requiredText(120),
    description: shortText(2_000).default(''),
    coverPhotoId: id.nullable().default(null),
  }),
  defaultAudience: 'family',
  childAccess: 'contribute',
  editPolicy: 'collaborative',
  immutableFields: [],
  manualMergeFields: ['description'],
});

export const photos = defineCollection({
  name: 'photos',
  module: 'photos',
  label: { one: 'photo', other: 'photos' },
  schema: z.object({
    albumId: id,
    fileId: id,
    caption: shortText(1_000).default(''),
    takenAt: isoDateTime.nullable().default(null),
    width: z.number().int().min(0).max(100_000).nullable().default(null),
    height: z.number().int().min(0).max(100_000).nullable().default(null),
    contentType: shortText(100),
    sizeBytes: z.number().int().min(0),
    source: provenance.nullable().default(null),
  }),
  parent: { kind: 'fixed', collection: 'albums', field: 'albumId' },
  defaultAudience: 'family',
  childAccess: 'contribute',
  editPolicy: 'collaborative',
  immutableFields: ['albumId', 'fileId', 'contentType', 'sizeBytes', 'source'],
  manualMergeFields: [],
});

export type Album = RecordOf<typeof albums>;
export type Photo = RecordOf<typeof photos>;
